export function formatDateToFullTime(date: Date | undefined): string {
	if (!date) return "";

	let hours = date.getHours();
	const minutes = date.getMinutes().toString().padStart(2, "0");
	const month = (date.getMonth() + 1).toString().padStart(2, "0");
	const day = date.getDate().toString().padStart(2, "0");
	const year = date.getFullYear();
	const ampm = hours >= 12 ? "PM" : "AM";

	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	const strHours = hours.toString().padStart(2, "0");

	return `${strHours}:${minutes} ${ampm} ${month}/${day}/${year}`;
}
